import api from './api';

export const portalIntegrationApi = {
  getAll: () => api.get('/api/portal-integrations'),
  submitLieferandoData: (data) => api.post('/api/portal-integrations/lieferando/submit', data),
  updateStatus: (portalName, status) => api.patch(`/api/portal-integrations/${portalName}/status`, { status }),
};
